import React from "react"
import Showcase from "../components/Showcase"
import { Chart } from "react-ame-components"

export class ChartPieExample extends React.Component {
  state = {
    cores: ["Javascript", "Java", "Typescript"],
    dataPieOptions: {
      label: "Linguagens de programação",
      data: [120, 60, 80],
      backgroundColor: [
        "rgb(255, 99, 132)",
        "rgb(54, 162, 235)",
        "rgb(255, 206, 86)",
      ],
      borderColor: ["#444", "#444", "#444"],
      borderWidth: 1,
    },
  }

  render() {
    return (
      <Showcase
        title="Componente Chart.Pie"
        description="Este componente serve para exibir um gráfico torta.">
        <Chart.Pie
          data={this.state.dataPieOptions}
          labels={this.state.cores}
          title="Gráfico Pie"
          height={100}
        />
      </Showcase>
    )
  }
}
